import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class ReportsAdminService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async listDefinitions() {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/reports"), await authenticatedApiConfig(this.authenticationProvider));
        return response.data.reports;
    }
    async runReport(reportType, params) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/admin/reports/:reportType/run", { reportType }), { params }, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async listRuns(query = {}) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/reports/runs"), {
            ...(await authenticatedApiConfig(this.authenticationProvider)),
            params: query,
        });
        return response.data;
    }
    async getRun(runId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/reports/runs/:runId", { runId }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async setSchedule(reportType, input) {
        const response = await axios.put(generateURL(this.environment.API_BASE_URL, "/admin/reports/:reportType/schedule", { reportType }), input, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async deleteSchedule(reportType) {
        await axios.delete(generateURL(this.environment.API_BASE_URL, "/admin/reports/:reportType/schedule", { reportType }), await authenticatedApiConfig(this.authenticationProvider));
    }
    async getDownload(runId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/admin/reports/runs/:runId/download", { runId }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
